var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSquareHalfBottomBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/Phosphor Icons / SquareHalfBottom"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 6.88235C4.5 5.84276 5.39543 5 6.5 5H25.5C26.6046 5 27.5 5.84276 27.5 6.88235V24.7647C27.5 25.8043 26.6046 26.6471 25.5 26.6471H6.5C5.39543 26.6471 4.5 25.8043 4.5 24.7647V6.88235ZM25.5 6.88235H6.5V24.7647H25.5V6.88235Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 10.1756C4.5 9.65575 4.94772 9.23438 5.5 9.23438H26.5C27.0523 9.23438 27.5 9.65575 27.5 10.1756C27.5 10.6953 27.0523 11.1167 26.5 11.1167H5.5C4.94772 11.1167 4.5 10.6953 4.5 10.1756Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10.1758C10.5523 10.1758 11 10.7489 11 11.4558V24.8958C11 25.6027 10.5523 26.1758 10 26.1758C9.44772 26.1758 9 25.6027 9 24.8958V11.4558C9 10.7489 9.44772 10.1758 10 10.1758Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10.1758C14.5523 10.1758 15 10.7489 15 11.4558V24.8958C15 25.6027 14.5523 26.1758 14 26.1758C13.4477 26.1758 13 25.6027 13 24.8958V11.4558C13 10.7489 13.4477 10.1758 14 10.1758Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10.1758C18.5523 10.1758 19 10.7489 19 11.4558V24.8958C19 25.6027 18.5523 26.1758 18 26.1758C17.4477 26.1758 17 25.6027 17 24.8958V11.4558C17 10.7489 17.4477 10.1758 18 10.1758Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10.1758C22.5523 10.1758 23 10.7489 23 11.4558V24.8958C23 25.6027 22.5523 26.1758 22 26.1758C21.4477 26.1758 21 25.6027 21 24.8958V11.4558C21 10.7489 21.4477 10.1758 22 10.1758Z",
    fill: "#4F4F4F"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareHalfBottomBlack);
export default __webpack_public_path__ + "static/media/SquareHalfBottomBlack.3cf418dea2635bceaeed30d606c4e9f9.svg";
export { ForwardRef as ReactComponent };